// extracted by mini-css-extract-plugin
export const carousel = "Carousel-module--carousel--5EYQl";
export const arrow_left = "Carousel-module--arrow_left--1YJ7b";
export const arrow_right = "Carousel-module--arrow_right--1p99B";